import {Component, Input, OnInit,} from '@angular/core';
import {TableLazyLoadEvent} from "primeng/table";
import {CallService} from "../../../../../../shared/services/call/call.service";
import {ICall} from "../../../../../../shared/services/call/interface/call.interface";
import {combineLatest, Subscription} from "rxjs";
import {Store} from "@ngrx/store";
import {selectCaseId} from "../../../../store/selectors/common-case.selector";

@Component({
  selector: 'app-case-calls',
  templateUrl: './case-calls.component.html',
  styleUrl: './case-calls.component.scss',
})

export class CaseCallsComponent implements OnInit {
  callType: any = null;
  loading: boolean = false;
  calls: ICall[] = [];
  @Input() callCardInformations: any;
  private subscription!: Subscription;

  constructor(
    public callService: CallService,
    private readonly store: Store,
  ) {
  }

  ngOnInit(): void {
    this.subscription = combineLatest([
      this.store.select(selectCaseId),
    ]).subscribe({
      next: ([
               caseId
             ]) => {
        if (caseId) {
          this.loadData({}, caseId);
        }
      },
    });

  }

  async loadData(event: TableLazyLoadEvent, caseId: any) {
    this.loading = true;
    this.callService.getFilter(event, {'filter.card.case.id': `$eq:${caseId}`}).subscribe((data: any) => {
      this.calls = data.items;
      this.loading = false;
    });
  }
}
